import { tempoApi } from '../tempoApi';
import type {
  CreateLoopRequest,
  Loop,
  PaginatedLoopResponse,
  UpdateLoopRequest,
} from '../types/loops';

const getLoops = async ({
  cursor = '',
}: {
  cursor?: string;
} = {}): Promise<PaginatedLoopResponse> =>
  tempoApi()
    .get(`api/v1/item-store/loops${cursor ? `?cursor=${cursor}` : ''}`)
    .json<PaginatedLoopResponse>();

const getLoop = async ({ loopId }: { loopId: number }): Promise<Loop> =>
  tempoApi().get(`api/v1/item-store/loops/${loopId}`).json<Loop>();

const createLoop = async (data: CreateLoopRequest): Promise<Loop> =>
  tempoApi().post('api/v1/item-store/loops', { json: data }).json<Loop>();

const updateLoop = async ({
  loopId,
  data,
}: {
  loopId: number;
  data: UpdateLoopRequest;
}): Promise<Loop> =>
  tempoApi().put(`api/v1/item-store/loops/${loopId}`, { json: data }).json<Loop>();

const patchLoop = async ({
  loopId,
  data,
}: {
  loopId: number;
  data: Partial<UpdateLoopRequest>;
}): Promise<Loop> =>
  tempoApi().patch(`api/v1/item-store/loops/${loopId}`, { json: data }).json<Loop>();

export const LoopsApi = {
  getLoops,
  getLoop,
  createLoop,
  updateLoop,
  patchLoop,
} as const;
